class classGrid {
    constructor(count = 0, data = [], hasMore = true, loading = false) {
        this.count = count;
        this.data = data;
        this.loading = loading;
        this.hasMore = hasMore;
    }
};
export default classGrid;
